import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ShoppingListDetail from '../shopping_lists/shopping_list_detail';
import { useTracker } from '../../operations/tracking_operations';
import {
  useListProductsBoardQuery,
  useUpdateShoppingListMutation,
} from '../../app/smorgAppSyncGraphQLApi';
import { shoppingListWithNewActivityRecord } from '../../services/products_board';
import {
  useGetShoppingListByIDAndParentQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const MyDayShoppingListView = () => {
  const { shoppingListID } = useParams();
  const navigate = useNavigate();
  const tracker = useTracker();

  const { data: userProfile } = useGetUserProfileQuery();

  const { data: productsBoard } = useListProductsBoardQuery();

  const { data: shoppingList } = useGetShoppingListByIDAndParentQuery(
    { id: shoppingListID, parentID: productsBoard?.id },
    {
      skip: !shoppingListID || !productsBoard?.id,
    },
  );

  const [updateShoppingList] = useUpdateShoppingListMutation();

  return (
    <ShoppingListDetail
      shoppingListId={shoppingListID}
      visible
      onShopEvent={async (vendorName, occurredOn, itemIds) => {
        tracker(
          userProfile,
          [{ name: 'Products shopped', args: { vendorName } }],
          ['numShops'],
        );
        const updatedShoppingList = shoppingListWithNewActivityRecord(
          shoppingList,
          'SHOPPED',
          occurredOn,
          vendorName,
          itemIds,
        );
        await updateShoppingList(updatedShoppingList);
      }}
      dismiss={() => navigate(-1)}
    />
  );
};

export default MyDayShoppingListView;
